
import { defineComponent, PropType } from "vue";
import { ProductCategoryRestService } from "@/services/rest/cpc-product-category-mgmt/ProductCategoryRestService";
import {
  CustomerCategoryImageRestDto,
  DpMainCategoryOverviewRestDto,
  ProductCategoryCustomerNameRestDto
} from "@/api/pharma-cpc-product-category-mgmt/models";
import { StatusEnum } from "@/api/enums/status-enum";
import { ProductCategoryCustomerNameRestDtoModel } from "@/models/api/pharma-cpc-product-category-mgmt/ProductCategoryCustomerNameRestDtoModel";
import { CustomerCategoryImageRestDtoModel } from "@/models/api/pharma-cpc-product-category-mgmt/CustomerCategoryImageRestDtoModel";

import InputText from "@/components/UI/InputText.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import CategoryImageEditor from "./CategoryImageEditor.vue";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {FormMixin} from "@/components/base/FormMixin";
import {ImageRestDto} from "@/components/layouts/catalog/categories/ImageRestDto";
import BaseOffcanvasButtonClose from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonClose.vue";



export default defineComponent({
  name: "DPMainCategory",
  mixins: [FormMixin],
  components: {
    BaseOffcanvasButtonClose,
    InputText,
    InputSelect,
    CategoryImageEditor,
    GenericFormWrapper
  },
  emits: ["edit"],
  props: {
    category: { type: Object as PropType<DpMainCategoryOverviewRestDto>, required: false },
    masterCategory: { type: Object as PropType<DpMainCategoryOverviewRestDto>, required: true },
    allLanguages: { type: Array as PropType<string[]>, required: true }
  },
  data() {
    return {
      docType: "CATEGORY_IMG" as const,
      name: ProductCategoryCustomerNameRestDtoModel.createWithDefaults() as ProductCategoryCustomerNameRestDto,
      customerCategoryImage: CustomerCategoryImageRestDtoModel.createWithDefaults() as CustomerCategoryImageRestDto,
      imageRestDto: {} as ImageRestDto,
      publishedStatus: StatusEnum.PUBLISHED
    };
  },
  mounted() {
    this.reloadContent();
  },
  computed: {
    StatusEnum() { return StatusEnum; },
    originalImage(): string {
      if (this.masterCategory?.image?.image_url) {
        return `<img height="40px" src="${this.masterCategory.image.image_url}" alt="" class="category-image">`;
      }
      if (this.masterCategory?.svg) {
        return `<div class="category-svg-container">${this.masterCategory.svg}</div>`;
      }
      return `<span class="text-muted">${this.$t('noImage')}</span>`;
    }
  },
  methods: {
    async doReload() {
      const nameResult = await ProductCategoryRestService.getInstance()
        .getProductCategoryCustomerName(this.category?.category.code);

      this.name = nameResult ?? ProductCategoryCustomerNameRestDtoModel.createWithDefaults();

      const image = await ProductCategoryRestService.getInstance()
        .getProductCategoryCustomerImage(this.category?.category.code);

      this.customerCategoryImage = image ?? CustomerCategoryImageRestDtoModel.createWithDefaults();

      this.imageRestDto = {
        image_document_key: this.customerCategoryImage.image_document_key,
        image: this.customerCategoryImage.image,
        svg: this.customerCategoryImage.svg,
      };

      this.publishedStatus = this.customerCategoryImage.is_hidden
        ? StatusEnum.NOT_PUBLISHED
        : StatusEnum.PUBLISHED;
    },
    async doSubmit() {
      await ProductCategoryRestService.getInstance()
        .updateProductCategoryCustomerName(this.name, this.category!.category.code);

      this.customerCategoryImage.is_hidden = this.publishedStatus === StatusEnum.NOT_PUBLISHED;

      await ProductCategoryRestService.getInstance()
        .updateProductCategoryCustomerImage(this.customerCategoryImage, this.category!.category.code);

      this.$emit('edit');
    },
    onImageChanged() {
      this.customerCategoryImage = {
        ...this.customerCategoryImage,
        ...this.imageRestDto
      };
      this.onFormDataChanged();
    }
  }
});
